import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

// Sample visit data
const rawData = {
  visit: [
    { id: 1, start_datetime: '2025-05-01 09:15:00', visitors: 2, amenity: 'lounge' },
    { id: 2, start_datetime: '2025-05-01 14:30:00', visitors: 1, amenity: 'clubhouse-gym' },
    { id: 3, start_datetime: '2025-05-02 10:45:00', visitors: 3, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 4, start_datetime: '2025-05-03 12:00:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 5, start_datetime: '2025-05-04 16:20:00', visitors: 2, amenity: 'clubhouse-gym' },
    { id: 6, start_datetime: '2025-05-05 11:10:00', visitors: 4, amenity: 'lounge' },
    { id: 7, start_datetime: '2025-05-07 13:00:00', visitors: 1, amenity: 'clubhouse-pools-or-jacuzzi' },
    { id: 8, start_datetime: '2025-05-09 15:15:00', visitors: 2, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 9, start_datetime: '2025-05-11 17:40:00', visitors: 1, amenity: 'clubhouse-gym' },
    { id: 10, start_datetime: '2025-05-12 10:30:00', visitors: 3, amenity: 'lounge' },
    { id: 11, start_datetime: '2025-05-13 14:15:00', visitors: 2, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 12, start_datetime: '2025-05-14 12:45:00', visitors: 1, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 13, start_datetime: '2025-05-16 09:30:00', visitors: 3, amenity: 'clubhouse-pools-or-jacuzzi' },
    { id: 14, start_datetime: '2025-05-18 13:20:00', visitors: 2, amenity: 'clubhouse-gym' },
    { id: 15, start_datetime: '2025-05-20 11:00:00', visitors: 1, amenity: 'lounge' },
    { id: 16, start_datetime: '2025-05-22 14:50:00', visitors: 3, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 17, start_datetime: '2025-05-24 15:40:00', visitors: 2, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 18, start_datetime: '2025-05-26 10:10:00', visitors: 4, amenity: 'clubhouse-gym' },
    { id: 19, start_datetime: '2025-05-28 16:30:00', visitors: 2, amenity: 'lounge' },
    { id: 20, start_datetime: '2025-05-30 17:15:00', visitors: 1, amenity: 'clubhouse-pools-or-jacuzzi' },

    { id: 21, start_datetime: '2025-06-01 09:20:00', visitors: 3, amenity: 'lounge' },
    { id: 22, start_datetime: '2025-06-02 11:35:00', visitors: 1, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 23, start_datetime: '2025-06-03 15:10:00', visitors: 2, amenity: 'clubhouse-gym' },
    { id: 24, start_datetime: '2025-06-04 10:50:00', visitors: 3, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 25, start_datetime: '2025-06-05 12:25:00', visitors: 1, amenity: 'lounge' },
    { id: 26, start_datetime: '2025-06-06 14:00:00', visitors: 2, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 27, start_datetime: '2025-06-08 13:40:00', visitors: 4, amenity: 'clubhouse-pools-or-jacuzzi' },
    { id: 28, start_datetime: '2025-06-10 16:30:00', visitors: 1, amenity: 'clubhouse-gym' },
    { id: 29, start_datetime: '2025-06-12 09:10:00', visitors: 2, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 30, start_datetime: '2025-06-14 11:50:00', visitors: 3, amenity: 'lounge' },
    { id: 31, start_datetime: '2025-06-15 10:15:00', visitors: 2, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 32, start_datetime: '2025-06-17 15:25:00', visitors: 1, amenity: 'clubhouse-gym' },
    { id: 33, start_datetime: '2025-06-19 13:30:00', visitors: 3, amenity: 'clubhouse-pools-or-jacuzzi' },
    { id: 34, start_datetime: '2025-06-21 14:45:00', visitors: 2, amenity: 'lounge' },
    { id: 35, start_datetime: '2025-06-23 11:40:00', visitors: 1, amenity: 'clubhouse-pool--jacuzzi' },
    { id: 36, start_datetime: '2025-06-25 12:30:00', visitors: 3, amenity: 'Clubhouse Pool  Jacuzzi' },
    { id: 37, start_datetime: '2025-06-27 15:35:00', visitors: 2, amenity: 'clubhouse-gym' },
    { id: 38, start_datetime: '2025-06-29 10:05:00', visitors: 4, amenity: 'clubhouse-pools-or-jacuzzi' },
    { id: 39, start_datetime: '2025-06-30 13:55:00', visitors: 1, amenity: 'lounge' },
  ],
};


// Transform data into grouped structure
function groupDataByDateAndAmenity(data) {
  const map = {};
  const amenitiesSet = new Set();

  data.visit.forEach((visit) => {
    const date = visit.start_datetime.slice(0, 10); // "YYYY-MM-DD"
    const amenity = visit.amenity;
    amenitiesSet.add(amenity);

    if (!map[date]) map[date] = {};
    if (!map[date][amenity]) map[date][amenity] = 0;

    map[date][amenity] += visit.visitors;
  });

  const labels = Object.keys(map).sort(); // sorted date strings
  const amenities = Array.from(amenitiesSet);

  const datasets = amenities.map((amenity, index) => {
    const color = `hsl(${(index * 60) % 360}, 70%, 50%)`;
    return {
      label: amenity,
      data: labels.map((date) => map[date]?.[amenity] || 0),
      borderColor: color,
      backgroundColor: color,
      tension: 0.3,
      fill: false,
    };
  });

  return { labels, datasets };
}

// Format date like "May 27"
function formatDateLabel(dateString) {
  const date = new Date(dateString);
  const options = { month: 'short', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}

const ChartComponent = () => {
  const { labels, datasets } = groupDataByDateAndAmenity(rawData);

  const chartData = {
    labels: labels.map(formatDateLabel),
    datasets,
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
      title: { display: true, text: 'Visitors per Amenity per Day' },
    },
  };

  return <Line data={chartData} options={chartOptions} />;
};

export default ChartComponent;
